
import { defineComponent, reactive, ref } from 'vue'
import { useReflectiveInjector, Type } from '@tanbo/vue-di-plugin'
import { ConfigService } from '@/services/config.service'
import LogoffHeader from './_components/header.vue'
import { LogoffService } from './logoff.service'
import LogoffSuccessModal from './_components/logoffSuccessModal.vue'
import { ToastService } from '@/services/toast.service'
import { BridgeService } from '@/services/bridge.service'
import { CookieService } from '@/services/cookie.service'

const OriginType = {
  OnlyShow: 'OnlyShow',
}

export default defineComponent({
  name: 'Logoff',
  components: {
    LogoffHeader,
    LogoffSuccessModal,
  },
  props: {
    closeToken: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const injector = useReflectiveInjector([LogoffService])
    const toastService = injector.get(ToastService)
    const config = injector.get(ConfigService as Type<ConfigService>)
    const logoffService = injector.get(LogoffService as Type<LogoffService>)
    const bridgeService = injector.get(BridgeService as Type<BridgeService>)
    const cookieService = injector.get(CookieService as Type<CookieService>)

    const viewModel = reactive({
      logo: config.getLogo,
      title: config.getTitle,
      accountDeleteProtocolLink: config.getAccountDeleteProtocolLink,
      logoffContent: config.getLogoffContent || '',
    })

    const isSuccessModalVisible = ref(false)
    const isAgree = ref(false)

    function toggleAgree() {
      isAgree.value = !isAgree.value
    }

    function clickClose() {
      window.close()
    }

    function handleConfirm() {
      if (!isAgree.value) {
        return
      }

      // 如果当前是仅展示模式，则显示提示弹窗
      if ((props.type as string).toLowerCase() === OriginType.OnlyShow.toLowerCase()) {
        isSuccessModalVisible.value = true
        return
      }

      logoffService.requestLogoff(props.closeToken as string).then(() => {
        cookieService.removeRecentLoginByOpenId(cookieService.getOpenId)
        bridgeService.exit()
        isSuccessModalVisible.value = true
      }).catch((err) => {
        toastService.showToast({ message: err.msg || '注销失败，请重试', duration: 3000 })
        setTimeout(() => {
          window.close()
        }, 3000)
      })
    }

    function openLogoffNotice() {
      window.open(viewModel.accountDeleteProtocolLink, '_blank')
    }

    return {
      viewModel,
      isSuccessModalVisible,
      clickClose,
      isAgree,
      toggleAgree,
      openLogoffNotice,
      handleConfirm,
      OriginType
    }
  }
})
